<template>
  <div class="row">
    <div class="col">
      <div class="row justify-between items-center">
        <div class="row items-center">
          <div
            class="bg-primary-pale rounded-borders-half q-pa-sm q-mr-sm"
            v-if="icon"
          >
            <QIcon :name="icon" color="primary" size="20px" />
          </div>
          <p class="text-capitalize">{{ label }}</p>
        </div>
        <p
          :class="[
            'text-weight-medium',
            budget.variance < 0 ? 'text-warning' : 'text-grey-10'
          ]"
        >
          {{ budget.variance | currency }}
        </p>
      </div>

      <SAIProgress
        class="q-mt-sm"
        :progress="(budget.actual / budget.budget) * 100"
        exceeded-color="warning"
        height="8px"
      />

      <div class="row justify-between q-pt-sm">
        <span class="text-grey-6"> Spent {{ budget.actual | currency }} </span>
        <span class="text-grey-6"> of {{ budget.budget | currency }} </span>
      </div>
    </div>

    <div class="column justify-center q-pl-sm" v-if="displayForwardArrow">
      <QIcon name="eva-arrow-ios-forward" size="20px" color="grey-10" />
    </div>
  </div>
</template>

<script>
import { QIcon } from 'quasar';
import { SAIProgress } from 'ecx.saigon.ui.common';

export default {
  name: 'BudgetProgress',
  props: {
    budget: {
      type: Object,
      default: () => ({})
    },
    icon: String,
    label: String,
    displayForwardArrow: Boolean
  },
  components: {
    QIcon,
    SAIProgress
  }
};
</script>
